var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"c-app-content is-sidebar-tiny"},[_c('comment',{attrs:{"type":"post","target_id":"0","isAll":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }